import jqueryDataUtil from "@/common/jqueryDataUtil";
$(function () {
  $(document).on("click", ".expandable-content__expand", function () {
    var topicpostId = jqueryDataUtil.requiredNumber($(this).closest(".topicpost-item__content"), "topicpost-id"); // mta.clickStat("topicpostlist_expand", { topicpostid: topicpostId });
  });
});